var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 .584c-1.269 0-2.51.376-3.565 1.081a6.4 6.4 0 0 0-2.363 2.88 6.42 6.42 0 0 0 1.391 6.992 6.4 6.4 0 0 0 3.285 1.756A6.418 6.418 0 0 0 13.416 7a6.43 6.43 0 0 0-1.882-4.535A6.42 6.42 0 0 0 7 .584m0 11.667a5.25 5.25 0 0 1-3.712-8.962A5.25 5.25 0 0 1 12.25 7a5.25 5.25 0 0 1-1.54 3.71A5.26 5.26 0 0 1 7 12.251m.583-5.493V3.499a.58.58 0 0 0-.171-.412A.59.59 0 0 0 7 2.916a.58.58 0 0 0-.412.171.59.59 0 0 0-.171.412v3.5c0 .155.062.303.171.412l1.75 1.75c.11.106.257.165.41.164a.58.58 0 0 0 .578-.578.58.58 0 0 0-.164-.41z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgClock;